module.exports = __webpack_public_path__ + "img/video-placeholder.84e447bb.svg";